import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { EditarDados } from "@/components/EditarDados";

const opt = "w-full text-left rounded-xl border border-slate-200 px-4 py-3 hover:bg-slate-50 transition-colors";

// Titular/tipo diferente da caderneta ou certidão: corrigir o processo, pedir documento novo ou confirmar (com nota).
export function MismatchReview({ p, item, onClose, onDone }) {
  const [ok, setOk] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (choice) => {
    if (choice === "ok" && !note.trim()) { toast.error("Escreva uma nota a explicar (ex.: herança, procuração)."); return; }
    setBusy(true);
    try {
      await api.post(`/processes/${p.id}/owner-review`, { kind: item.review, choice, note: note.trim() || null });
      toast.success(choice === "ok" ? "Registado como correto" : "Documento pedido de novo");
      onClose(); onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const fix = async () => {
    setBusy(true);
    try { await api.post(`/processes/${p.id}/apply-fix`, { action: item.fix.action, args: item.fix.args }); toast.success("Processo corrigido"); onClose(); onDone(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="mismatch-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-ec-green">{item.label}</DialogTitle>
          <DialogDescription data-testid="mismatch-text">{item.text}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {item.review === "tipo" && item.fix
            ? <button disabled={busy} onClick={fix} className={opt} data-testid="mismatch-fix">Corrigir o processo</button>
            : <EditarDados p={p} onDone={() => { onClose(); onDone(); }} trigger={(start) => (
                <button disabled={busy} onClick={start} className={opt} data-testid="mismatch-fix">Corrigir o processo</button>)} />}
          <button disabled={busy} onClick={() => send("pedir")} className={opt} data-testid="mismatch-request">Pedir documento novo</button>
          <button disabled={busy} onClick={() => setOk(true)} className={opt} data-testid="mismatch-ok">Está correto (herança, procuração…)</button>
          {ok && (
            <div className="space-y-2 pt-1">
              <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Explique porque está correto (obrigatório)" data-testid="mismatch-note" />
              <div className="flex justify-end">
                <button disabled={busy || !note.trim()} onClick={() => send("ok")} data-testid="mismatch-ok-save"
                  className="px-4 py-2 rounded-lg bg-ec-green text-white font-semibold hover:bg-ec-greenDark transition-colors disabled:opacity-60">Guardar</button>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
